module.exports = __webpack_public_path__ + "static/media/water.25072e26.svg";